module.exports = __webpack_public_path__ + "static/media/pp-shield-long.eb8caa4c.svg";